import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-photos-icon',
  templateUrl: './photos-icon.component.html',
  styleUrl: './photos-icon.component.scss',
  standalone: false
})
export class PhotosIcon {}
